module.exports = __webpack_public_path__ + "img/CMbg.f08240ec.jpg";